import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootPrintPortalManager_ds_shippingcontents_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { orderId: number, shipmentId: number, fullTextSearch?: string }): 
  Promise<{ result: { ShipmentLineId?: number, LicensePlateId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, ShipmentLine?: { ExpectedPackagedAmount?: number, OrderLineNumber?: number, ExpectedPackaged?: { ShortName?: string } }, LicensePlate?: { LookupCode?: string, Location?: { Id?: number, Name?: string }, ShippingContainer?: { Id?: number, LookupCode?: string, ParentShippingContainer?: { Id?: number, LookupCode?: string } } }, Lot?: { LookupCode?: string, Material?: { Id?: number, LookupCode?: string }, VendorLot?: { Id?: number, LookupCode?: string, Vat?: string } }, Packaged?: { ShortName?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil(inParams.shipmentId)) {
      missingRequiredInParams.push('\'shipmentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintPortalManager/datasources/ds_shippingcontents_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { orderId: number, shipmentId: number, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { ShipmentLineId?: number, LicensePlateId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, ShipmentLine?: { ExpectedPackagedAmount?: number, OrderLineNumber?: number, ExpectedPackaged?: { ShortName?: string } }, LicensePlate?: { LookupCode?: string, Location?: { Id?: number, Name?: string }, ShippingContainer?: { Id?: number, LookupCode?: string, ParentShippingContainer?: { Id?: number, LookupCode?: string } } }, Lot?: { LookupCode?: string, Material?: { Id?: number, LookupCode?: string }, VendorLot?: { Id?: number, LookupCode?: string, Vat?: string } }, Packaged?: { ShortName?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil(inParams.shipmentId)) {
      missingRequiredInParams.push('\'shipmentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintPortalManager/datasources/ds_shippingcontents_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { orderId: number, shipmentId: number, fullTextSearch?: string, $keys: { ShipmentLineId?: number, LicensePlateId?: number, LotId?: number, PackagedId?: number }[] }): 
  Promise<{ result: { ShipmentLineId?: number, LicensePlateId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, ShipmentLine?: { ExpectedPackagedAmount?: number, OrderLineNumber?: number, ExpectedPackaged?: { ShortName?: string } }, LicensePlate?: { LookupCode?: string, Location?: { Id?: number, Name?: string }, ShippingContainer?: { Id?: number, LookupCode?: string, ParentShippingContainer?: { Id?: number, LookupCode?: string } } }, Lot?: { LookupCode?: string, Material?: { Id?: number, LookupCode?: string }, VendorLot?: { Id?: number, LookupCode?: string, Vat?: string } }, Packaged?: { ShortName?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil(inParams.shipmentId)) {
      missingRequiredInParams.push('\'shipmentId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintPortalManager/datasources/ds_shippingcontents_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      orderId: number, shipmentId: number, fullTextSearch?: string    }) {
        if(isNil(inParams.orderId)) {
          return true; 
        }
        if(isNil(inParams.shipmentId)) {
          return true; 
        }
      return false;
    }
}
